import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Card from "../../components/Cards/Card";

export function Simulador({ app, config }) {
  const { selections } = useSelections();
  const [selectedValue, setselectedValue] = useState("Consolidado");
  const history = useHistory();
  const [showSimulador, setShowSimulador] = useState();

  const validateShowSimulador = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;

          setShowSimulador(value);
        });
      }
    },
    [app]
  );

  function handleChange(value) {
    app.field("Simulador").selectMatch(value);
  }

  useEffect(() => {
    if (app) {
      const visaoField = selections.find((s) => s.qField === "Simulador");
      setselectedValue(visaoField?.qSelected);
      validateShowSimulador("bczGzMC");
      showSimulador === "0" && history.push("/overview");
    }
  }, [app, history, selections, showSimulador, validateShowSimulador]);

  return (
    <div className="app simulador">
      <div className="appContent">
        <LayoutWrapper>
          <Grid container width={"100%"}>
            <Box component={"h1"}>{`Simulador`}</Box>
            <Grid className="container-line-one-insights">
              <FormControl className="container-form-control">
                <RadioGroup
                  defaultValue="Consolidado"
                  row
                  name="row-radio-buttons-group"
                  className="radio-group radio-group-button-export"
                  value={selectedValue}
                  onChange={(e) => handleChange(e.target.value)}
                  sx={{ marginLeft: "20px" }}
                >
                  <FormControlLabel
                    value="Consolidado"
                    control={
                      <Radio
                        size="small"
                        defaultChecked
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Consolidado"
                  />

                  <FormControlLabel
                    value="Extra (Sell out total)"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Extra(Sell out total)"
                  />

                  <FormControlLabel
                    value="Área de Atuação Sell out"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Área de Atuação Sell out"
                  />

                  <FormControlLabel
                    value="Área de Atuação Positivação"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Área de Atuação Positivação"
                  />

                  <FormControlLabel
                    value="Golden Stores Sell out"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Golden Stores Sell out"
                  />

                  <FormControlLabel
                    value="Golden Stores Distribuição"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Golden Stores Distribuição"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid width={"100%"}>
              <Card
                app={app}
                className={"container-numbers-card"}
                exportTable
                exportTableId="GKbDtw"
                exportContainer
              >
                <NativeObject
                  app={app}
                  key="GKbDtw"
                  type={"table"}
                  reference={{
                    id: "GKbDtw",
                  }}
                  className={"number-card"}
                  style={{
                    height: "700px",
                    width: "100%",
                  }}
                />
              </Card>
            </Grid>
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

Simulador.defaultProps = {
  app: null,
  config: {},
};

Simulador.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};
